<template>
  <v-container class="grey lighten-5" fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Edytuj firmę
          </v-card-title>
          <v-card-text>
            <CompanyAddEdit
                :id="this.id"
                :nipHint="nipHint"
            ></CompanyAddEdit>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Oddziały
          </v-card-title>
          <v-card-text>
            <CompanyBranches
                :id="this.id"
                url-delete="/api/price-list/company-branch/{id}"
            ></CompanyBranches>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CompanyAddEdit from "@/components/price-list/CompanyAddEdit";
import CompanyBranches from "@/components/price-list/CompanyBranches";

export default {
  components: {
    CompanyAddEdit,
    CompanyBranches,
  },
  props: {
    id: {
      type: [String],
      required: true,
    }
  },
  data() {
    return {
      nipHint:
        'Zmiana NIP-u spowoduje odpięcie aktualnie przypiętej firmy z głównej tabeli i próbę dopasowania ' +
        'potwierdzonej firmy z takim NIP-em, o ile istnieje dokładnie jedno takie dopasowanie.',
    }
  },
}
</script>